import { ModalDetalhesErroUploadController } from './modal-detalhe-upload.controller';

export class ModalHistoricoUploadsController implements angular.IController {
  public uploads = [];

  constructor($scope, $uibModalInstance, private $uibModal, UploadService) {
    $scope.cancelar = function () {
      $uibModalInstance.dismiss('cancel');
    };

    UploadService.listarJobs().then((jobs) => {
      this.uploads = jobs.map((job) => {
        if (job.retorno) { job.retorno = JSON.parse(job.retorno); }
        return job;
      });
    });
  }

  detalharErro(upload) {
    this.$uibModal.open({
      animation: false,
      template: require('./modal-detalhe-upload.html'),
      controller: ModalDetalhesErroUploadController,
      controllerAs: 'vm',
      windowClass: 'modal-historico-uploads',
      resolve: { upload: () => upload },
    });
  }
}
